
import {useEffect, useState} from "react"

export const r2json = (response: any) => {
  try {
      const json = response.json()
      return json;
  } catch (error) {
      console.log("tryParseJson:error: ", error)
      return null;
  }
}

export const empty = (v: any) => {
  return (v === null || v === undefined || (typeof(v) == "string" && v.length === 0) || (typeof(v) == "object" && Object.keys(v).length === 0)) ? true : false
}

export const kopecks2rubStr = (kopecks: number) =>{
  if(empty(kopecks)) return ""
  let formatter = Intl.NumberFormat("ru-RU", {style: "currency", currency: "RUB"});
  return formatter.format(kopecks/100)
}

export const useFetch = (url: string )=> {
  const [data, setData] = useState(null);
  const [fail, setFail] = useState(false);
  const [msg, _] = useState("");
  const [loading, setLoading] = useState(true);

  async function fetchData() {
    const response = await fetch(url);
    const json = await response.json();
    console.log("fetch_res:", response)
    console.log("fetch_json:", json)
    setFail(!response.ok)
    setData(json);
    setLoading(false)
  }

  useEffect(() => {
    fetchData()
    return () => {}
    // eslint-disable-next-line
  }, []);

  return {loading, fail, data, msg};
};

export function date2str(date: Date, dateMark: string = '-', timeMark: string = ':') {
  if(isNaN(date.getTime())) return { date: '', time: '' };
	let dateStr = date.getFullYear() + dateMark + (date.getMonth() + 1).toString().padStart(2, '0')
   + dateMark + date.getDate().toString().padStart(2, '0');
	let dateTimeStr =  date.getHours().toString().padStart(2, '0') + timeMark
   + date.getMinutes().toString().padStart(2, '0') + timeMark + date.getSeconds().toString().padStart(2, '0');
	return { date: dateStr, time: dateTimeStr };
}

export function cutText(str: string, len: number = 70, markContinue: string = '...', markStop: string = ' '): string{
  if(empty(str)) return ''
  if(str.length < len) return str
  str = str.substr(0, len)
  let stopIdx = empty(markStop) ? str.length : str.lastIndexOf(markStop)
  return (stopIdx !== -1 ? str.substr(0, stopIdx) : str) + markContinue
}

export function cutTextTwoParts(str: string, markInto: string = '...', countFromStart: number = 18, countFromEnd: number = 18): string{
  if(empty(str)) return ''
  let strLen = str.length
  if(strLen < countFromStart + countFromEnd) return str
  return `${str.substr(0, countFromStart)}${markInto}${str.substr(-countFromEnd)}`
}

export function insert2str(str: string, idx: number, val: string): string {
  return str.substr(0, idx) + val + str.substr(idx);
}

export interface IValidatePhoneResult {
  phone: string,
  ok: boolean
}

// Приводит любой ввод к маске +7(XXX)XXX-XX-XX по мере набора номера
export function formatPhoneRU(raw: string): string {
  let digits = (raw || '').replace(/\D/g, '')
  if(digits.length === 0) return ''
  // нормализуем код страны: 8XXXXXXXXXX и XXXXXXXXXX -> 7XXXXXXXXXX
  if(digits[0] === '8') digits = '7' + digits.slice(1)
  else if(digits[0] !== '7') digits = '7' + digits
  digits = digits.slice(0, 11)
  const nat = digits.slice(1) // до 10 цифр национального номера
  // Закрывающие разделители добавляем только когда за ними уже есть цифра,
  // иначе при удалении форматтер тут же дописывает их обратно и стереть нельзя
  let out = '+7'
  if(nat.length > 0) out += '(' + nat.slice(0, 3)
  if(nat.length > 3) out += ')' + nat.slice(3, 6)
  if(nat.length > 6) out += '-' + nat.slice(6, 8)
  if(nat.length > 8) out += '-' + nat.slice(8, 10)
  return out
}

export function isValidPhoneRU(raw: string): boolean {
  let digits = (raw || '').replace(/\D/g, '')
  if(digits[0] === '8') digits = '7' + digits.slice(1)
  return /^7\d{10}$/.test(digits)
}

// Совместимость со старым API формы заказа звонка
export function validatePhoneRU(phone: string): IValidatePhoneResult {
  const formatted = formatPhoneRU(phone)
  return { phone: formatted, ok: isValidPhoneRU(formatted) }
}

export function validateEmail(email: string): boolean {
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test((email || '').trim())
}

// Оставляет только цифры, ограничивает 12 знаками (ИНН ЮЛ = 10, ФЛ/ИП = 12)
export function formatINN(raw: string): string {
  return (raw || '').replace(/\D/g, '').slice(0, 12)
}

// Проверка ИНН: 10 цифр (ЮЛ) или 12 цифр (ФЛ/ИП), без контрольной суммы
export function validateINN(inn: string): boolean {
  const v = (inn || '').replace(/\D/g, '')
  return v.length === 10 || v.length === 12
}

export function isStrictNested(obj: object, props: string): boolean {
  if(props === '') return true
  var propsArr: Array<string> = props.split('.')
  var temp = obj
  for (var prop in propsArr) {
    //@ts-ignore
    if (temp[propsArr[prop]] === 'undefined' || !temp[propsArr[prop]]) return false
    //@ts-ignore
    temp = temp[propsArr[prop]]
  }
  return true
}
//@ts-ignore
export function isFail(data, reqProps: string = ''): { jsonData: any, fail: boolean, failMsg: string} {
  if("err_code" in data && "message" in data) {
    return { jsonData: data, fail: true, failMsg: data.message }
  }
  if(isStrictNested(data, reqProps)) {
    return { jsonData: data, fail: false, failMsg: ''}
  }
  return { jsonData: data, fail: true, failMsg: JSON.stringify(data)}
}

export function strictNestedObj(obj: object, props: string): any {
  if(props === '') return null
  var propsArr: Array<string> = props.split('.')
  var temp = obj
  for (var prop in propsArr) {
    //@ts-ignore
    if (temp[propsArr[prop]] === 'undefined' || !temp[propsArr[prop]]) return null
    //@ts-ignore
    temp = temp[propsArr[prop]]
  }
  return temp
}


export function unpackServerData(obj: any, reqProps: string = ''): { data: any, failMsg: string} {
  if("err_code" in obj && "message" in obj) return { data: obj, failMsg: obj.message }
  let successObj = strictNestedObj(obj, reqProps)
  if(successObj !== null) return { data: successObj, failMsg: ''}
  return { data: obj, failMsg: JSON.stringify(obj)}
}

// interface IQuerySendMail {
//   setLoading: React.Dispatch<React.SetStateAction<boolean>>,
//   setFailMsg: React.Dispatch<React.SetStateAction<string>>,
//   setOkMsg: React.Dispatch<React.SetStateAction<string>>,
//   senderName: string,
//   destName: string,
//   destMail: string,
//   title: string,
//    text: string,
// }